import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Button, TextInputField } from '../../../helpers'

import { reviseSellerPO } from '../../../services/api/sellerPO'
import { raiseToast } from '../../../services/redux/reducers/toast/toast'
import { getUOMStr, round } from '../../../utils'


const RevisePO = (props) => {
    const { 
        sellerPO,
        sellerPOItems,
        sellerPIPunch, 
        sellerPIPunchItems,
        materialBrands,
        materialDetails,
        setIsLoading,
        getSellerPO
    } = props

    const dispatch = useDispatch()

    const [revisedPOItems, setRevisedPOItems] = useState([])

    useEffect(() => {
        if(sellerPOItems.length > 0){
            let updatedSellerPOItems = JSON.parse(JSON.stringify(sellerPOItems))
            let updatedRevisedSellerPOItems = []

            updatedSellerPOItems.map(eachPOItem => {
                if(eachPOItem.statusId != 6){
                    const activeSellerPIPunchIds = []
                    sellerPIPunch.map(eachSellerPIPunch => {
                        if(eachSellerPIPunch.statusId === 1){
                            activeSellerPIPunchIds.push(eachSellerPIPunch.sellerPIPunchId)
                        }
                    })
                    
                    const relatedSellerPIPunchItems = sellerPIPunchItems.filter(eachSellerPIPunchItem => eachSellerPIPunchItem.sellerPOItemId === eachPOItem.sellerPOItemId && activeSellerPIPunchIds.includes(eachSellerPIPunchItem.sellerPIPunchId))

                    let piPunchedQuantity = 0
                    relatedSellerPIPunchItems?.map(eachSellerPIPunchItem => {
                        piPunchedQuantity += eachSellerPIPunchItem.qty
                    })
                    eachPOItem.piPunchedQuantity = piPunchedQuantity
                    eachPOItem.revisedPOQuantity = eachPOItem.qty

                    updatedRevisedSellerPOItems.push(eachPOItem)
                }
            })

            setRevisedPOItems(updatedRevisedSellerPOItems)
        }
    }, [sellerPOItems, sellerPIPunchItems])

    const handleInputQtyChange = (event, sellerPOItemId) => {
        const eventValue = event.target.value

        const updatedPOItems = revisedPOItems.map(eachPOItem => {
            if(eachPOItem.sellerPOItemId === sellerPOItemId){
                eachPOItem.revisedPOQuantity = eventValue
            }
            return eachPOItem 
        })
        setRevisedPOItems(updatedPOItems)
    }

    const handleInputQtyBlur = (event, sellerPOItemId) => {
        if(!event.target.value){
            event.target.value = 0
        }
        const eventValue = round(event.target.value)

        const updatedPOItems = revisedPOItems.map(eachPOItem => {
            if(eachPOItem.sellerPOItemId === sellerPOItemId){
                if(eventValue < eachPOItem.piPunchedQuantity){
                    dispatch(raiseToast({ severity: 'error', detail: `Revised quantity cant be less than ${eachPOItem.piPunchedQuantity}`}))
                    eachPOItem.revisedPOQuantity = eachPOItem.piPunchedQuantity
                } 
                else if(eventValue > eachPOItem.qty){
                    dispatch(raiseToast({ severity: 'error', detail: `Revised quantity cant be more than ${eachPOItem.qty}`}))
                    eachPOItem.revisedPOQuantity = eachPOItem.qty
                } else {
                    eachPOItem.revisedPOQuantity = eventValue
                }
            }
            return eachPOItem 
        })
        setRevisedPOItems(updatedPOItems)
    }

    const handleCreateRevisedSellerPO = async () => {
        let nonZeroRevisedQtyExists = false  
        let emptyInputQtyExists = false
        revisedPOItems.map(eachItem => {
            if(eachItem.revisedPOQuantity){
                nonZeroRevisedQtyExists = true
            }
            if(!eachItem.revisedPOQuantity && eachItem.revisedPOQuantity !== 0){
                emptyInputQtyExists = true
            }
        })

        if(emptyInputQtyExists){
            return
        }

        if(!nonZeroRevisedQtyExists){
            return dispatch(raiseToast({severity:'error', detail:'Atleast one item qty should be greater than 0'})) 
        }
        
        if (window.confirm("Are you sure you want to revise the seller po?")){
            setIsLoading(true)
            const clientActiveSellerPIPunches = sellerPIPunch.filter(eachSellerPIPunch => eachSellerPIPunch.statusId === 1)
            const response = await reviseSellerPO(sellerPO.sellerPOId, {revisedSellerPOItems: revisedPOItems, clientActiveSellerPIPunches})
            console.log("response", response)

            if (response?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', detail: response.data.error, life: 5000}))
            }else{
                getSellerPO()
                setIsLoading(false)
                dispatch(raiseToast({severity:'success', detail:'Seller PO has been Revised.'})) 
            }
        }
    }

    return (
        <div className='flex flex-column justify-content-between h-100'>
            <div className="p-card p-2">
                <div className="flex flex-wrap py-2 w-full">
                    <div className="flex pl-2 w-full header-style" style={{ color: "#6c757d" }}>
                        <div className="mb-2" style={{ width: '5%' }}>Sr</div>
                        <div className="mb-2" style={{ width: '20%' }}>Product</div>
                        <div className="mb-2" style={{ width: '40%' }}>Specifications</div>
                        <div className="mb-2" style={{ width: '10%' }}>PO Qty</div>
                        <div className="mb-2 ml-2" style={{ width: '10%' }}>PI Punched Qty</div>
                        <div className="mb-2" style={{ width: '10%' }}>Input Qty</div>
                    </div>
                    <div className="w-full">
                        {
                            revisedPOItems?.map((eachSellerPOItem, index) => {
                                const relatedMaterialData = materialDetails?.find(eachMaterial => eachMaterial.materialId === eachSellerPOItem.materialId)
                                const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterialData?.brandId)

                                return (
                                    <div className="flex pl-2 data-style">
                                        <div className="py-2" style={{ width: '5%', alignSelf: "center" }}>{index+1}</div>
                                        <div className="py-2" style={{ width: '20%', alignSelf: "center" }}>
                                            {eachSellerPOItem?.materialId} | {relatedMaterialBrand?.brandName && `${relatedMaterialBrand?.brandName} - `}{relatedMaterialData?.productName} {relatedMaterialData?.variantName && ` - ${relatedMaterialData?.variantName}`}
                                        </div>
                                        <div className="py-2" style={{ width: '40%', alignSelf: "center" }}>
                                            {relatedMaterialData?.productSpecification} - {getUOMStr(relatedMaterialData?.UOM, relatedMaterialData?.UOMValue)}
                                        </div>
                                        <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>{eachSellerPOItem.qty}</div>
                                        <div className="py-2 ml-2" style={{ width: '10%', alignSelf: "center" }}>{eachSellerPOItem.piPunchedQuantity}</div>
                                        <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>
                                            <TextInputField 
                                                name="inputQty" 
                                                labelText="" 
                                                placeholder="" 
                                                style={{ width: "100%" }} 
                                                value={eachSellerPOItem?.revisedPOQuantity} 
                                                keyfilter="num" 
                                                onChange={(event) => handleInputQtyChange(event, eachSellerPOItem.sellerPOItemId)} 
                                                onBlur={(event) => handleInputQtyBlur(event, eachSellerPOItem.sellerPOItemId)}
                                            />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className='flex justify-content-end'>
                <Button className="h-2rem p-2" label="REVISE PO" onClick={handleCreateRevisedSellerPO} />
            </div>
        </div>
    )
}

export default RevisePO